/**
 * Yeni sifre kurallari. Sunucudaki SifreKurali ile aynidir (en az 6 karakter, Burak 04.10.2026);
 * burada yalniz kullaniciya erken uyari vermek icin denetlenir, asil denetim sunucuda.
 */
export const SIFRE_EN_AZ_UZUNLUK = 6;

/** Yeni sifre kurala uyuyor mu? Uymuyorsa mesaj, uyuyorsa undefined. */
export const yeniSifreHatasi = (sifre: string | undefined | null): string | undefined => {
    if (!sifre || sifre.trim().length === 0)
        return 'Şifre alanını doldurunuz!';

    if (sifre.length < SIFRE_EN_AZ_UZUNLUK)
        return `Şifre en az ${SIFRE_EN_AZ_UZUNLUK} karakter olmalıdır.`;

    return undefined;
}

/** Profil menusunden kendi sifresini degistirme formu. */
export const sifreDegistirHatasi = (mevcut: string, yeni: string, tekrar: string): string | undefined => {
    if (!mevcut)
        return 'Mevcut şifrenizi giriniz.';

    const kural = yeniSifreHatasi(yeni);

    if (kural)
        return kural;

    if (yeni !== tekrar)
        return 'Yeni şifre ile tekrarı aynı değil.';

    if (yeni === mevcut)
        return 'Yeni şifre mevcut şifrenizle aynı olamaz.';

    return undefined;
}

/** Kullanici tanimlari formu: yeni kullanicida sifre zorunlu, duzenlemede bos birakilirsa degismez. */
export const kullaniciFormuSifreHatasi = (duzenleme: boolean, sifre: string | undefined): string | undefined => {
    if (duzenleme && (!sifre || sifre.length === 0))
        return undefined;

    return yeniSifreHatasi(sifre);
}
